import * as VisuallyHiddenAll from '@radix-ui/react-visually-hidden';

const VisuallyHidden = VisuallyHiddenAll.Root;

export { VisuallyHidden };
